import { render, staticRenderFns } from "./BandDescend.vue?vue&type=template&id=788fcd28&scoped=true&"
import script from "./BandDescend.vue?vue&type=script&lang=js&"
export * from "./BandDescend.vue?vue&type=script&lang=js&"
import style0 from "./BandDescend.vue?vue&type=style&index=0&id=788fcd28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788fcd28",
  null
  
)

export default component.exports